import { toast } from "react-hot-toast"

export const notify = ({
  message, type,
}: {
  message: string, type: 'success' | 'error',
}) => {
    toast(message, {
        style: {
          background: type === 'success' ? '#5cb85c' : '#D13B4C',
          color: 'white',
        },
        // duration: ,
      })
}